import { render } from "./AskDoubtTeacher.vue?vue&type=template&id=3ec89def&scoped=true"
import script from "./AskDoubtTeacher.vue?vue&type=script&lang=js"
export * from "./AskDoubtTeacher.vue?vue&type=script&lang=js"

import "./AskDoubtTeacher.vue?vue&type=style&index=0&id=3ec89def&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec89def"]])

export default __exports__